namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_skill_config, {
		
		flex: {
			basis: '18rem',
		},
		
		Skill_value: {
			color: $mol_theme.special,
		},
		
		Skill_title: {
			flex: {
				basis: '8rem',
				shrink: 1,
				grow: 1,
			},
		},
		
	} )
	
}
